<template>
    <div class="full-page" v-loading="loading">
        <div class="login-part-div">
            <loginComponent @login-check-complete="loginCallback" />
        </div>
    </div>
</template>

<script setup>
    import {ref, getCurrentInstance, toRef} from "vue";
    import loginComponent from "@/components/loginComponent"
    import {usePageinfo} from "@/stores/pageinfo";

    const { proxy } = getCurrentInstance()
    const props = defineProps(["page"])

    const loading = ref(true)
    const pageInfoRef = toRef(usePageinfo())

    function loginCallback(type) {
        loading.value = false
        if (type == 0){
            proxy.$router.push({name: `demoIndex2`})
        }else{
            if (null == props.page){
                proxy.$router.push({name: `demoIndex2`})
            }else{
                const array = props.page.split("-")
                let path = ""
                pageInfoRef.value.infoJson = {}

                for (let i=0; i<array.length; i++){
                    const v = array[i]

                    if (i == 0){
                        path += "/" + v
                    }else if(i == 1 && v == "editStaff"){
                        pageInfoRef.value.infoJson.editStaff = true
                        pageInfoRef.value.infoJson.department = array[2] == "null" ? null : Number(array[2])
                        pageInfoRef.value.infoJson.cardIndex = Number(array[3])

                        break

                    }else{
                        pageInfoRef.value.infoJson[v] = true
                    }

                }

                proxy.$router.push({path: path})
            }
        }
    }

</script>

<style scoped>
    .full-page {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .login-part-div {
        position: absolute;
        top: 300vh;
        left: 0;
        width: 475px;
        height: 475px;
    }
</style>